export const locale = {
  lang: 'vn',
  data: {
    ERROR: {
      HTTP: {
        403: {
          'TITLE': '403 ERROR',
          'MESSAGE': 'Không có quyền truy cập trang'
        }
      },
    },
  },
};
